import React, { useContext } from 'react';
import { Snackbar, Alert } from '@mui/material';
import { FeedbackContext } from '../contexts/FeedbackContext';

const FeedbackMessage = () => {
  const { feedback } = useContext(FeedbackContext);

  return (
    <Snackbar open={!!feedback.message} autoHideDuration={3000}>
      <Alert severity={feedback.type}>
        {feedback.message}
      </Alert>
    </Snackbar>
  );
};

export default FeedbackMessage;